// extracted by mini-css-extract-plugin
module.exports = {"model-header":"style_model-header__39wBF","header-content":"style_header-content__2CUxY","title":"style_title__2VDA4"};